import { Navbar } from '@/components/Navbar/Navbar';
import { useAuth } from '@/contexts/auth';
import { Navigate, Outlet } from 'react-router-dom';

function AuthLayout() {
  const { signed } = useAuth();

  if (signed) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}

export default AuthLayout;
